const swiper01 = new Swiper('.testimonials-main', {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 1,
    navigation: {
        nextEl: '#swiper-button-next',
        prevEl: '#swiper-button-prev',
    },
    breakpoints: {
        2560:{
            slidesPerView: 1,
            spaceBetween: 20,
        },
        1024:{
            slidesPerView: 1,
            spaceBetween: 20,
        },
        1440:{
            slidesPerView: 1,
            spaceBetween: 20,
        },
        426:{
            slidesPerView: 1.2,
            spaceBetween: 15,
        },
        375:{
          slidesPerView: 1.2,
          spaceBetween: 30,
        },
      320:{
          slidesPerView: 1.1,
          spaceBetween: 15,
        }
    }
})
